import type { ApiResourceCollectionMeta } from '@sorrem/shared';

/** Where the page after `meta`'s starts; undefined once the list is all loaded (or a page came back empty). */
export function resolveNextPageStart(meta: ApiResourceCollectionMeta): number | undefined {
    const nextStart = meta.start + meta.count;
    return meta.count > 0 && nextStart < meta.total ? nextStart : undefined;
}
